<template>
    <div>
        <buttonlist
                ref="SetBtn"
                @help="help"
        ></buttonlist>
        <div style="width:690px;min-width:690px;margin-top: 5px">
            <tr>
                <td style="width:80px;min-width:80px">{{$t('getapi[4361]')}}</td>
                <td style="width:150px;min-width:150px">
                    <routejump :urlNo="15">
                    <el-input
                            v-model="workcenter_code"
                            type="text"
                            readonly
                            size="mini"
                    >
                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectCode"></i>
                    </el-input>
                    </routejump>
                </td>
                <td style="width:80px;min-width:80px">{{$t('getapi[882]')}}</td>
                <td style="width:150px;min-width:150px">
                    <el-input v-model="workcenter_name" size="mini" :readonly="true" class="readO"></el-input>
                </td>
                <td style="width:80px;min-width:80px">{{$t('getapi[6370]')}}</td>
                <td style="width:150px;min-width:150px">
                    <el-input v-model="report_measure_method" size="mini" :readonly="true" class="readO"></el-input>
                </td>
            </tr>
        </div>
        <el-tabs :tab-position="'top'" style="margin-top: 5px">
            <el-tab-pane :label="$t('getapi[6368]')" name="0" id="xpane-0">
                <vxe-table :data="dataSet.dt" size="mini" :loading="loading" header-cell-class-name="headerclass"
                           ref='VXTable'
                           :height="tableHeight"
                           :highlight-current-row="true"
                           stripe
                           border
                           resizable
                           :cell-style="cellstyle">
                    <vxe-table-column show-footer-overflow v-for="item in dataSet.TbHeader"
                                      :key="item.Headen"
                                      :field="item.Headen"
                                      :title="item.Headcn"
                                      :align="item.align"
                                      width="80px"
                    >
                        <template scope="scope" >
                    <span v-if="item.Headen != 'Item_Code' && item.Headen !='SumFlag'">{{ scope.row[item.Headen] | thousandth}}</span>
                            <span v-else>{{ scope.row[item.Headen]}}</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6369]')" name="1">
                <div>
                    <tr>
                        <td><el-button @click="selectItem" type="primary" size="mini">{{$t('getapi[7044]')}}</el-button></td>
                    </tr>
                </div>
                <div id="main" :style="{ width: Cwidth + 'px', height: tableHeight - 60 + 'px' }"></div>
            </el-tab-pane>
        </el-tabs>

        <el-dialog v-dialogDrag :visible.sync="isShowItem" width="40%">
            <div>
                <template>
                <el-transfer
                        id="test"
                        :titles="['可选项目', '显示项目']"
                        v-model="value"
                        @change="handleChange"
                        :data="itemArr" class="test"></el-transfer>

                </template>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowItem = false" size="mini">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="sure" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>


        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/MPS/GetWorkCenterPopupDataList'"
                  @callback="getCode" ref="workcentercode"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import echarts from 'echarts';

    export default {
        name: '2_chargemanagedata',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            },
            Cwidth(){
                return document.getElementById('silderRight') == undefined?1000:document.getElementById('silderRight').clientWidth
            }
        },
        data() {
            const generateData = _ => {
                const data = [];
                return data;
            }
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                workcenter_code: '',
                workcenter_name: '',
                report_measure_method: '',
                isShowItem:false,
                itemArr:generateData(),
                value: [{key:'CEL',label:'CEL'}],
                option: [],
                rightarr: [],//右侧显示项目
                scrollTop:0,
            };
        },
        watch: {
            'dataSet.dt': function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.VXTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.VXTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3995]"),this.$t("getapi[26]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let parm = {
                    workcenter_code: that.workcenter_code
                }
                that.$http.urlpost('/Pro/MPS/GetMonthManChargeManageData', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        for(let i =0;i<that.dataSet.dt.length;i++){
                            if(that.dataSet.dt[i].Item_Code == '实际产能：'){
                                that.dataSet.dt.splice(i,1)
                            }
                        }
                        let x = []
                        for (let i = 1; i < that.dataSet.TbHeader.length - 1; i++) {
                            x = [...x,that.dataSet.TbHeader[i].Headcn]
                        }
                        let datalrcn  = []
                        let datalrcnall = []
                        let datasjcn  = []
                        let datasjcnall = []
                        let head = []
                        for(let i=0;i<that.dataSet.dt.length;i++){
                            if(that.dataSet.dt[i].Item_Code != '理论产能：' && that.dataSet.dt[i].Item_Code != '实际产能：'){
                                if(that.workcenter_name == '激光'){
                                    that.dataSet.dt[i]['D2026-01'] = that.dataSet.dt[i]['D2026-01'] != null ? Math.round(that.dataSet.dt[i]['D2026-01'] * 0.38):null
                                }
                                if(that.workcenter_name == '喷粉'){
                                    that.dataSet.dt[i]['D2026-01'] = that.dataSet.dt[i]['D2026-01'] != null ? Math.round(that.dataSet.dt[i]['D2026-01'] * 0.58):null
                                }
                            }
                            if(that.dataSet.dt[i].Item_Code == '理论产能：'){
                                datalrcnall = that.dataSet.dt[i]
                            }
                            if(that.dataSet.dt[i].Item_Code == '实际产能：'){
                                datasjcnall = that.dataSet.dt[i]
                            }
                            head = [...head,that.dataSet.dt[i].Item_Code]
                        }
                        for(let x in datalrcnall){
                            if(x != 'Item_Code' && x != 'SumFlag'){
                                datalrcn = [...datalrcn,datalrcnall[x]]
                            }
                        }
                        for(let x in datasjcnall){
                            if(x != 'Item_Code' && x != 'SumFlag'){
                                datasjcn = [...datasjcn,datasjcnall[x]]
                            }
                        }
                        that.loading = false;
                        console.log(datalrcn)
                        that.showchar(x,head,datalrcn,datasjcn)
                        that.showchar_()
                        that.authority();
                    } else {
                        that.loading = false;
                        that.$message.error(res.Msg);
                    }
                });
            },
            showchar_(){
                let that = this
                that.itemArr = []
                that.value = []
                for(let i=0;i<that.dataSet.dt.length;i++){
                    if(that.dataSet.dt[i].Item_Code != '合计：' && that.dataSet.dt[i].Item_Code != '理论产能：' && that.dataSet.dt[i].Item_Code != '实际产能：'){
                        that.itemArr = [...that.itemArr, {
                            key: that.dataSet.dt[i].Item_Code,
                            label: that.dataSet.dt[i].Item_Code
                        }]
                        that.value = [...that.value,that.dataSet.dt[i].Item_Code]
                    }
                }
                let arr1 = [] // 过滤掉合计 理论产能 实际产能
                for(let i =0;i<that.dataSet.dt.length;i++){
                    if(that.dataSet.dt[i].Item_Code != '合计：' && that.dataSet.dt[i].Item_Code != '理论产能：' && that.dataSet.dt[i].Item_Code != '实际产能：'){
                        arr1 = [...arr1, that.dataSet.dt[i]]
                    }
                }
                let arr2 = []
                for(let i = 0;i<arr1.length;i++){
                    let arr3 = []
                    for(let x in arr1[i]){
                        if(x != 'Item_Code' && x != 'SumFlag'){
                            arr3 = [...arr3,arr1[i][x]]
                        }
                    }
                    arr2 = [...arr2,{
                        key: arr1[i].Item_Code,
                        value: arr3
                    }]
                }
                let newOption = JSON.parse(that.defaultOption)
                for(let i = 0;i<that.value.length;i++){
                    for(let j = 0;j<arr2.length;j++){
                        if(that.value[i] == arr2[j].key) {
                            newOption.legend.data.push(arr2[j].key)
                            newOption.series.push({
                                name: arr2[j].key,
                                data: arr2[j].value,
                                type: 'bar',
                                stack: '总量',
                            })

                            arr2.splice(j,1)
                        }
                    }
                }
                console.log(arr2)
                if(that.value.length > 0){
                    let arrotherval = [0,0,0,0,0,0,0,0,0,0,0,0]
                    for(let i = 0;i<arr2.length;i++){
                        console.log(arr2[i].value[0])
                        arrotherval[0] += (arr2[i].value[0] == null?0:arr2[i].value[0])
                        arrotherval[1] += (arr2[i].value[1] == null?0:arr2[i].value[1])
                        arrotherval[2] += (arr2[i].value[2] == null?0:arr2[i].value[2])
                        arrotherval[3] += (arr2[i].value[3] == null?0:arr2[i].value[3])
                        arrotherval[4] += (arr2[i].value[4] == null?0:arr2[i].value[4])
                        arrotherval[5] += (arr2[i].value[5] == null?0:arr2[i].value[5])
                        arrotherval[6] += (arr2[i].value[6] == null?0:arr2[i].value[6])
                        arrotherval[7] += (arr2[i].value[7] == null?0:arr2[i].value[7])
                        arrotherval[8] += (arr2[i].value[8] == null?0:arr2[i].value[8])
                        arrotherval[9] += (arr2[i].value[9] == null?0:arr2[i].value[9])
                        arrotherval[10] += (arr2[i].value[10] == null?0:arr2[i].value[10])
                        arrotherval[11] += (arr2[i].value[11] == null?0:arr2[i].value[11])
                    }
                    console.log(arrotherval)
                    newOption.legend.data.push(this.$t('getapi[224]'))
                    newOption.series.push({
                        name: this.$t('getapi[224]'),
                        data: arrotherval,
                        type: 'bar',
                        stack: '总量',
                    })
                }
                console.log('newOption' + JSON.stringify(newOption))
                that.cht.clear();
                that.cht.setOption(newOption);
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            //选择工作中心代码
            selectCode() {
                let that = this;
                that.$refs.workcentercode.clearInput(true);
            },
            getCode(val) {
                let that = this;
                console.log(val)
                that.workcenter_code = val.workcenter_code
                that.workcenter_name = val.workcenter_name
                that.report_measure_method = val.report_measure_method
                that.getView()
            },
            showchar(x,head,datalrcn,datasjcn) {
                let that = this
                that.cht = echarts.init(document.getElementById("main"));
                that.cht.resize();
                that.option = {
                    xAxis: {
                        type: 'category',
                        data: x
                    },
                    yAxis: {
                        type: 'value'
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: head
                    },
                    series: [
                        {
                            name: '理论产能：',
                            data: datalrcn,
                            type: 'line'
                        },
                        {
                            name: '实际产能：',
                            data: datasjcn,
                            type: 'line'
                        }
                    ]
                }
                that.defaultOption = JSON.stringify(that.option)
                that.cht.clear();
                that.cht.setOption(that.option);
            },
            selectItem(){
                let that = this
                that.itemArr = []
                for(let i=0;i<that.dataSet.dt.length;i++){
                    if(that.dataSet.dt[i].Item_Code != '合计：' && that.dataSet.dt[i].Item_Code != '理论产能：' && that.dataSet.dt[i].Item_Code != '实际产能：'){
                        that.itemArr = [...that.itemArr, {
                            key: that.dataSet.dt[i].Item_Code,
                            label: that.dataSet.dt[i].Item_Code
                        }]
                    }
                }
                that.isShowItem = true
            },
            sure(){
                let that = this
                that.isShowItem = false
                let arr1 = [] // 过滤掉合计 理论产能 实际产能
                for(let i =0;i<that.dataSet.dt.length;i++){
                    if(that.dataSet.dt[i].Item_Code != '合计：' && that.dataSet.dt[i].Item_Code != '理论产能：' && that.dataSet.dt[i].Item_Code != '实际产能：'){
                        arr1 = [...arr1, that.dataSet.dt[i]]
                    }
                }
                let arr2 = []
                for(let i = 0;i<arr1.length;i++){
                    let arr3 = []
                    for(let x in arr1[i]){
                        if(x != 'Item_Code' && x != 'SumFlag'){
                            arr3 = [...arr3,arr1[i][x]]
                        }
                    }
                    arr2 = [...arr2,{
                        key: arr1[i].Item_Code,
                        value: arr3
                    }]
                }
                let newOption = JSON.parse(that.defaultOption)
                for(let i = 0;i<that.value.length;i++){
                    for(let j = 0;j<arr2.length;j++){
                        if(that.value[i] == arr2[j].key) {
                            newOption.legend.data.push(arr2[j].key)
                            newOption.series.push({
                                name: arr2[j].key,
                                data: arr2[j].value,
                                type: 'bar',
                                stack: '总量',
                            })

                            arr2.splice(j,1)
                        }
                    }
                }
                console.log(arr2)
                if(that.value.length > 0){
                    let arrotherval = [0,0,0,0,0,0,0,0,0,0,0,0]
                    for(let i = 0;i<arr2.length;i++){
                        console.log(arr2[i].value[0])
                        arrotherval[0] += (arr2[i].value[0] == null?0:arr2[i].value[0])
                        arrotherval[1] += (arr2[i].value[1] == null?0:arr2[i].value[1])
                        arrotherval[2] += (arr2[i].value[2] == null?0:arr2[i].value[2])
                        arrotherval[3] += (arr2[i].value[3] == null?0:arr2[i].value[3])
                        arrotherval[4] += (arr2[i].value[4] == null?0:arr2[i].value[4])
                        arrotherval[5] += (arr2[i].value[5] == null?0:arr2[i].value[5])
                        arrotherval[6] += (arr2[i].value[6] == null?0:arr2[i].value[6])
                        arrotherval[7] += (arr2[i].value[7] == null?0:arr2[i].value[7])
                        arrotherval[8] += (arr2[i].value[8] == null?0:arr2[i].value[8])
                        arrotherval[9] += (arr2[i].value[9] == null?0:arr2[i].value[9])
                        arrotherval[10] += (arr2[i].value[10] == null?0:arr2[i].value[10])
                        arrotherval[11] += (arr2[i].value[11] == null?0:arr2[i].value[11])
                    }
                    console.log(arrotherval)
                    newOption.legend.data.push(this.$t('getapi[224]'))
                    newOption.series.push({
                        name: this.$t('getapi[224]'),
                        data: arrotherval,
                        type: 'bar',
                        stack: '总量',
                    })
                }
                console.log('newOption' + JSON.stringify(newOption))
                that.cht.clear();
                that.cht.setOption(newOption);
            },
            cellstyle({row, column, rowIndex, columnIndex}) {
                let that = this;
                if (columnIndex == 0) {
                    return "background:rgb(237,190,203)"
                }
            },
            handleChange(value, direction, movedKeys){
                console.log(value, direction, movedKeys);
                let that = this
                that.rightarr = value
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
